<ng-template #ptoConfigModal let-modal>
  <div class="modal-header justify-content-between">
    <h4 class="fw-bold">
      Time Off Plan <span *ngIf="planChosen"> - {{ chosenPlan.Name }}</span>
    </h4>
    <button type="button" class="close ms-3" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container [formGroup]="timeOffModalForm">
    <div class="modal-body">
      <div class="row" *ngIf="!planChosen">
        <div class="col-lg-12">
          <label>Time Off Plan</label>
          <select appAutoFocus formControlName="Id" class="form-control">
            <option [disabled]="true" [ngValue]="null"></option>
            <ng-container *ngFor="let ptoConfig of ptoConfigs">
              <option *ngIf="!isAlreadyAdded(ptoConfig)" value="{{ ptoConfig.Id }}">
                {{ ptoConfig.Name }}
              </option>
            </ng-container>
          </select>
          <div *ngIf="timeOffModalForm.get('Id').errors?.required" class="input-error">
            *required
          </div>
        </div>
      </div>
      <ng-container *ngIf="planChosen">
        <div class="headerGrid">
          <div>
            <div class="d-flex flex-column justify-content-between h-100">
              <div>
                <div class="row mb-5 w-100">
                  <div class="col-12">
                    <div class="d-flex justify-content-start">
                      <label class="me-3">Active</label>
                      <lib-toggle-switch
                        id="activeToggle"
                        formControlName="Active"></lib-toggle-switch>
                    </div>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        timeOffModalForm.errors?.CannotActivateInactivePlan || showInactivePlan
                      "
                      >You cannot activate this Time Off Plan because it is inactive at the Company
                      level.</small
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-start">
                      <div class="d-flex flex-column justify-content-center">
                        <label for="anniversaryDate" class="me-3">Anniversary Date:</label>
                      </div>
                      <div class="input-group mb-0 w-50">
                        <input
                          formControlName="AnniversaryDate"
                          class="form-control datepicker"
                          ngbDatepicker
                          id="anniversaryDate"
                          #d="ngbDatepicker"
                          [firstDayOfWeek]="7"
                          [placement]="['bottom-end', 'top-end']" />
                        <img
                          src="assets/icons/calendar.svg"
                          (click)="d.toggle()"
                          class="icon-append" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="d-flex justify-content-start">
                    <label class="me-3">Override Client Rates</label>
                    <lib-toggle-switch
                      id="overrideClientRates"
                      formControlName="OverrideClientRates"></lib-toggle-switch>
                  </div>
                </div>
                <div class="col-12" *ngIf="timeOffModalForm.errors?.NotUniqueOverrides">
                  <small class="form-text text-danger"
                    >The override rates must be different than the Client rates. You must modify the
                    rates or uncheck the 'Override Client Rates' checkbox.</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div></div>
          <div>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex justify-content-center flex-column">
                        <label for="carryOver">Carry Over: </label>
                      </div>
                      <input
                        class="form-control mb-0 w-50 text-end"
                        id="carryOver"
                        formControlName="CarryOver"
                        step="0.01" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex justify-content-center flex-column">
                        <label for="carryOver">Accrued: </label>
                      </div>
                      <input
                        class="form-control mb-0 w-50 text-end"
                        id="accrued"
                        formControlName="Accrued"
                        step="0.01" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex justify-content-center flex-column">
                        <label for="carryOver">Used: </label>
                      </div>
                      <input
                        class="form-control mb-0 w-50 text-end"
                        id="used"
                        formControlName="Used"
                        step="0.01" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex justify-content-center flex-column">
                        <label for="carryOver">Balance: </label>
                      </div>
                      <input
                        class="form-control mb-0 w-50 text-end"
                        id="balance"
                        formControlName="Balance"
                        step="0.01" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <ng-container *ngIf="!timeOffModalForm.get('OverrideClientRates').value">
          <h4 class="fw-bold">Client Rates</h4>
          <div class="row">
            <div class="col-6" *ngFor="let rate of chosenPlan.TimeoffRates">
              <div class="card card-shadow">
                <div class="card-header bg-white">
                  <h4 class="fw-bold">
                    {{ rate.AccrueAfter }} {{ rate.AccruePeriodDescription
                    }}<span *ngIf="rate.AccrueAfter > 1">s</span>
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <small class="col-7"> Period: </small>
                    <small class="col-5 text-end">
                      {{ rate.AccrueAfter }} {{ rate.AccruePeriodDescription
                      }}<span *ngIf="rate.AccrueAfter > 1">s</span>
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Rate: </small>
                    <small class="col-5 text-end">
                      {{ rate.Rate | number: '1.4-4' }}
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Accrual Period Cap: </small>
                    <small class="col-5 text-end">
                      {{ rate.AccrualPeriodCap | number: '1.2-2' }}
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Accrual Total Cap: </small>
                    <small class="col-5 text-end">
                      {{ rate.AccrualTotalCap | number: '1.2-2' }}
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Used Total Cap: </small>
                    <small class="col-5 text-end">
                      {{ rate.UsedTotalCap | number: '1.2-2' }}
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Balance Total Cap: </small>
                    <small class="col-5 text-end">
                      {{ rate.BalanceTotalCap | number: '1.2-2' }}
                    </small>
                  </div>
                  <div class="row mb-3">
                    <small class="col-7"> Balance Carry Over Cap: </small>
                    <small class="col-5 text-end">
                      {{ rate.BalanceCarryOverCap | number: '1.2-2' }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="timeOffModalForm.get('OverrideClientRates').value">
          <div class="row">
            <div class="col-9">
              <h4 class="fw-bold">Employee Rates</h4>
            </div>
            <div class="col-3">
              <button class="btn btn-primary" (click)="addNewRate()" [disabled]="readonly">
                <i class="fas fa-plus"></i> Add New
              </button>
            </div>
          </div>
          <div class="row" *ngIf="employeeRates.errors?.DuplicateAccrualPeriods">
            <div class="col-12">
              <p>Duplicate Accrual Periods</p>
            </div>
          </div>
          <div class="rate-wrapper mt-3" formArrayName="EmployeeRates">
            <div
              class="card card-shadow"
              *ngFor="let rate of employeeRates.controls; let i = index"
              [formGroupName]="i">
              <div class="card-header bg-white">
                <h4 class="fw-bold">
                  {{ rate.get('AccrueAfter').value }}
                  <span *ngIf="rate.get('AccruePeriod').value == 0"
                    >Month<span *ngIf="rate.get('AccrueAfter').value > 1">s</span></span
                  >
                  <span *ngIf="rate.get('AccruePeriod').value == 1"
                    >Year<span *ngIf="rate.get('AccrueAfter').value > 1">s</span></span
                  >
                </h4>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <div class="grid-wrapper">
                    <div class="d-flex flex-column justify-content-center">
                      <small> Period: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        formControlName="AccrueAfter"
                        type="number"
                        step="1" />
                    </small>
                    <small>
                      <select
                        class="form-control form-control-sm default-form-control"
                        formControlName="AccruePeriod">
                        <option [ngValue]="null" disabled></option>
                        <option [ngValue]="0">
                          Month<span *ngIf="rate.get('AccrueAfter').value > 1">s</span>
                        </option>
                        <option [ngValue]="1">
                          Year<span *ngIf="rate.get('AccrueAfter').value > 1">s</span>
                        </option>
                      </select>
                    </small>
                    <div class="d-flex flex-column justify-content-center">
                      <small> Rate: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        type="number"
                        step="0.01"
                        formControlName="Rate" />
                    </small>
                    <small></small>
                    <div class="d-flex flex-column justify-content-center">
                      <small> Accrual Period Cap: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        type="number"
                        step="0.01"
                        formControlName="AccrualPeriodCap" />
                    </small>
                    <small></small>
                    <div class="d-flex flex-column justify-content-center">
                      <small> Accrual Total Cap: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        type="number"
                        step="0.01"
                        formControlName="AccrualTotalCap" />
                    </small>
                    <small></small>
                    <div class="d-flex flex-column justify-content-center">
                      <small> Used Total Cap: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        type="number"
                        step="0.01"
                        formControlName="UsedTotalCap" />
                    </small>
                    <small></small>
                    <div class="d-flex flex-column justify-content-center">
                      <small> Balance Total Cap: </small>
                    </div>
                    <small>
                      <input
                        class="form-control form-control-sm default-form-control"
                        type="number"
                        step="0.01"
                        formControlName="BalanceTotalCap" />
                    </small>
                    <small></small>
                    <ng-container *ngIf="chosenPlan.BalanceRule == 0">
                      <div class="d-flex flex-column justify-content-center">
                        <small> Balance Carry Over Cap: </small>
                      </div>
                      <small>
                        <input
                          class="form-control form-control-sm default-form-control"
                          type="number"
                          step="0.01"
                          formControlName="BalanceCarryOverCap" />
                      </small>
                      <small></small>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="card-footer border-top-0 text-end bg-white">
                <button class="btn btn-secondary" (click)="removeRate(i)">Delete</button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="modal-footer text-end">
      <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button
        class="btn btn-primary"
        [disabled]="timeOffModalForm.invalid || readonly"
        (click)="formSubmit()">
        Save
      </button>
    </div>
  </ng-container>
</ng-template>
